export const LOG = (() => {
  const log = console.log;
  // eslint-disable-next-line no-sequences
  const LOG = (...x) => (LOG.enabled && log(...x), x.slice(-1)[0]);
  LOG.enabled = true;
  const silently = f => {
    const save = LOG.enabled;
    LOG.enabled = false;
    const retValue = f();
    LOG.enabled = save;
    return retValue;
  };
  LOG.silently = silently;
  console.log = LOG;
  return LOG;
})();
